export default function useScriptsToRoute(currentRoute: string) {
  let useMgid = true;
  let useGpt = true;
  let useMarfeel = true;
  let useGtm = true;
  let useNavbar = true;
  let useComscore = true;
  let useFullScreen = false;
  let useRun = true;
  let useCnn = true;
  let specifyId = undefined;

  switch (currentRoute) {
    case '/guia-de-compras':
      useMgid = false;
      useGpt = false;
      useMarfeel = false;
      useComscore = false;

      useNavbar = false;
      useFullScreen = true;
      useRun = false;
      useCnn = true;

      specifyId = 'GTM-PT37RWSC';
      break;
    case '/live':
      useMgid = false;
      useGpt = false;
      useMarfeel = false;
      useComscore = false;
      useCnn = false;

      useNavbar = false;
      useFullScreen = true;
      useRun = false;

      specifyId = 'GTM-K9569WH2';
      break;
    case '/oppo':
      useMgid = false;
      useGpt = false;
      useMarfeel = false;
      useComscore = false;
      useCnn = false;
      useNavbar = false;
      useFullScreen = true;
      useRun = false;
      break;
    default:
      break;
  }

  // sobrescreve useCnn se for página de erro
  if (currentRoute === '/404' || currentRoute === '/500') {
    useCnn = false;
  }

  return {
    useMgid: useMgid,
    useGpt: useGpt,
    useMarfeel: useMarfeel,
    useCnn: useCnn,
    useGtm: useGtm,
    specifyId: specifyId,
    useNavbar: useNavbar,
    useComscore: useComscore,
    useRun: useRun,
    useFullScreen: useFullScreen,
  };
}
